<template>
  <v-row dense>
    <v-col cols="12" sm="12">
      <SelectCampanha
        :independent="true"
        :selected="getLayout.campanha"
        @onChanged="campanha = $event"
      />
    </v-col>

    <v-col cols="12" sm="12">
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="12" align="center" justify="center">
              <canvas
                ref="canvas"
                :width="canvasSettings.width"
                :height="canvasSettings.height"
                class="elevation-3"
              ></canvas>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row align="center" justify="center">
            <v-btn color="orange dark-2" outlined rounded small @click="save()">
              <v-icon left>mdi-content-save</v-icon>Alterar
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { LayoutImage } from "@/services/materiais";
import { mapGetters } from "vuex";

export default {
  name: "EditLayoutImage",

  components: {
    SelectCampanha: () => import("@/components/select/SelectCampanha")
  },

  data() {
    return {
      url: null, // url da imagem
      canvasImage: null, // imagem atual renderizada no canvas

      campanha: null,

      canvas: null,
      context: null,
      canvasSettings: {
        width: 453 /*425.19*/,
        height: 642 /*595.27*/
      },
    };
  },

  computed: {
    ...mapGetters("materiais", ["getLayout"])
  },

  methods: {
    setImageCanvas() {
      let image = new Image();

      image.onload = () => {
        this.updateCanvas();
      };

      image.src = this.url;
      this.canvasImage = image;
    },

    updateCanvas() {
      if (this.canvasImage) {
        this.context.drawImage(
          this.canvasImage,
          0,
          0,
          this.canvasSettings.width,
          this.canvasSettings.height
        );
      }
    },

    async save() {
      if (!this.campanha) {
        this.$toast.warning("Selecione uma campanha");
        return;
      }

      let descricao = await this.$swal.inputText(
        "Descrição do Layout",
        true,
        "Descrição",
        this.getLayout.descricao
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição da template");
        return;
      }

      try {
        descricao = descricao.replaceAll("/", "-")
        let data = {
          descricao: descricao,
          campanha: this.campanha,
        };

        this.$loading.setLoading(true);
        let result = await new LayoutImage().update(this.getLayout.id, data);
        this.$toast.success(result);
        this.$router.push("/materiais/layouts");
      } catch (error) {
        this.$toast.error(error);
      } finally {
        this.$loading.setLoading(false);
      }
    },

    init() {
      this.canvas = this.$refs.canvas;
      this.context = this.canvas.getContext("2d");

      this.campanha = this.getLayout.campanha;
      this.url = this.getLayout.url;
      this.setImageCanvas();
    }
  },

  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
.swatch-style {
  cursor: pointer !important;
  height: "30px" !important;
  width: "30px" !important;
  border-radius: 4px;
  padding: 10px;
}
</style>
